import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=5d8f0a36&scoped=true"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=5d8f0a36&prod&scoped=true&lang=css"
import style1 from "./Reserve.vue?vue&type=style&index=1&id=5d8f0a36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f0a36",
  null
  
)

export default component.exports